// @ts-nocheck
import { createRef } from "react";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import DetailFileManagement from "../fields/procedureFileManagementFields/detailProcedureFileManagement";
import {
  detailTableSortFile,
  fileTags,
  getTimeZoneString,
  handleUploadErrorCode,
  proposedChangeTags,
  revisionFromList,
  revisionInfoMandatoryCheck,
  savedInRadioValues,
  shareTaskMassage,
  userRoles,
  getRequestDateMoment,
} from "../../../publicDictionaryValues";
import FileSectionBase from "../../../commonComponents/fileBase";
import createProcedureTableData from "../createProcedureTableData";
import NormalModal, { ModalWithScroll } from "../../../../base/basicComponents/modal";
import { timeOutMins } from "../../../../base/basicComponents/modal/controlPageBehavior";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import "../../../pages/procedureDetail/createProcedureDetail/style/index.module.scss";
import RevisionInformation from "../fields/revisionInformationFields/detailRevisionInformation";
import UpdateProcedureFileManagement from "../fields/procedureFileManagementFields/updateProcedureFileManagement";
import { getPendingAction } from "../../../../store/actions/procedureDetailPageActions";
import { PendingActionTypes } from "../../../../store/actions/constants";
import { checkLatestProcedureInfo } from "../../../pages/procedureDetail/utils";
import { debounce } from "lodash-es";
import { HeaderWithReminder } from "app/pages/procedureDetail/createProcedureDetail/utils";

const ref = createRef();
const procedureModalRef = createRef();
const procedureFileRef = createRef();
const procedureFileTableRef = createRef();
const procedureFileModalTableRef = createRef();
const revisionInfoRef = createRef();
const editRef = createRef();

export default class ProcedureFileSection extends FileSectionBase {
  constructor(props: any) {
    super(props);
    this.state = {
      procedureFlientPathDisabled: false,
      procedureSaveInValue: savedInRadioValues.systemOnly,
      initOrLastSaveProcedureSaveInValue: savedInRadioValues.systemOnly,
      initOrLastSubmitProcedureSaveInValue: savedInRadioValues.systemOnly,
      procedureSubmited: false,
      procedureSaved: false,
      initProcedureDataList: [],
      initClientServerPath: "",
      procedureFileStepId: null,
      isModalOpen: false,
      modalChildContent: "",
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      isScrollModalOpen: false,
      scrollModalContent: "",
      scrollModalTitle: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
      isProcedureFileEditToolTipOpen: false,
      isShowTLButton: this.handleIsShowTLButton(),
      isShowApplyJbButton: this.handleIsShowApplyJbButton(),
      procedurePendingProcessId: null,
      applyForJBProcessStatus: null,
      clientServerJB: null,
      procedureStatusJB: null,
    };
    // @ts-ignore
    this.replaceList = [];
    // @ts-ignore
    this.tableFiles = [];
    // @ts-ignore
    this.fileList = [];
  }

  getRecordRoles = () => {
    // @ts-ignore
    const loginUserRoles = JSON.parse(localStorage.getItem("user"))?.roles;
    const recordRoles: any[] = [];
    loginUserRoles?.forEach((item: any) => {
      if (item.projectID === this.props.procedureAccountId) {
        recordRoles.push(item.roleID);
      }
    });

    return recordRoles;
  };

  isTlAndAbove = () => {
    const recordRoles = this.getRecordRoles();
    const rolesList = [userRoles.Manager, userRoles.Assistant, userRoles.TeamLeader];
    return (
      recordRoles?.findIndex(
        (roleItem) => rolesList.findIndex((item) => item === roleItem) !== -1
      ) > -1
    );
  };

  isAsAndAbove = () => {
    const recordRoles = this.getRecordRoles();
    const rolesList = [
      userRoles.Manager,
      userRoles.Assistant,
      userRoles.TeamLeader,
      userRoles.Specialist,
    ];
    return (
      recordRoles?.findIndex(
        (roleItem) => rolesList.findIndex((item) => item === roleItem) !== -1
      ) > -1
    );
  };

  handleIsShowTLButton = () => {
    return (
      this.isTlAndAbove() && (this.props.procedureStatus === 3 || this.props.procedureStatus === 7)
    );
  };

  handleIsShowApplyJbButton = () => {
    return (
      this.isAsAndAbove() && (this.props.procedureStatus === 3 || this.props.procedureStatus === 7)
    );
  };

  getFileList = () => {
    // @ts-ignore
    return this.fileList;
  };

  // @ts-ignore
  handleUploadLoading = (type: any) => {
    this.props.handleUploadLoading();
  };

  setUploadFileNum = () => {
    this.props.setUploadFileNum();
  };

  setFileNum = () => {
    this.props.setFileNum();
  };

  createLine = (dataList: any, fileId: any, fileName: any) => {
    const lineId = this._generateGUID();
    const fileKey = this._generateGUID();
    if (this.props.procedureStatus === 3) {
      dataList.unshift({
        data: [
          { name: "lineId", value: lineId },
          { name: "fileId", value: fileId },
          { name: "fileKey", value: fileKey },
          {
            name: "fileName",
            value: fileName,
            tagValue: fileTags.new,
          },
          {
            name: "uploadedDate",
            value: this._formateDate(getTimeZoneString(this._getDate())),
          },
          {
            name: "uploadByName",
            // @ts-ignore
            value: this.user.identityUserInfo.englishName,
          },
          {
            name: "uploadBy",
            // @ts-ignore
            value: this.user.identityUserInfo.internalUserID,
          },
          {
            name: "proposedChange",
            value: proposedChangeTags.new,
          },
          { name: "note", value: "" },
          { name: "approveDate", value: null },
          { name: "approveTime", value: null },
          { name: "fileOperate", value: 1 },
        ],
        checked: false,
      });
    } else {
      dataList.unshift({
        data: [
          { name: "lineId", value: lineId },
          { name: "fileId", value: fileId },
          { name: "fileKey", value: fileKey },
          {
            name: "fileName",
            value: fileName,
          },
          {
            name: "uploadedDate",
            value: this._formateDate(getTimeZoneString(this._getDate())),
          },
          {
            name: "uploadByName",
            // @ts-ignore
            value: this.user.identityUserInfo.englishName,
          },
          {
            name: "uploadBy",
            // @ts-ignore
            value: this.user.identityUserInfo.internalUserID,
          },
          { name: "note", value: "" },
          { name: "approveDate", value: null },
          { name: "fileOperate", value: 1 },
        ],
        checked: false,
      });
    }
  };

  // @ts-ignore
  uploadFileOnSuccess = (result: any, returnPara: any, ref: any) => {
    handleUploadErrorCode(result.errorCode);
    const procedureFileData = ref.current.getDataList();
    this.createLine(procedureFileData, result.storageFileID, returnPara.fileName);
    // @ts-ignore
    this.handleUploadLoading();
    ref.current.updateDataList(procedureFileData);
    // @ts-ignore
    if (returnPara.fileIndex < this.fileList.length - 1) {
      this.uploadFile(returnPara.fileIndex + 1, ref);
    }
  };

  _procedureSaveSuccess = (result: any) => {
    this.setState({
      procedureSaved: true,
      initOrLastSaveProcedureSaveInValue: this.state.procedureSaveInValue,
    });
    this.props.setIsProcedureFileModalChange();
    this.handleResetLock("ProcedureFile");
    this.props.procedureSaveSuccess(result);
  };

  procedureFileOnSave = (ref: any) => {
    this.props.showLoading();
    let combineDatalist = [];
    if (ref.current.getDataList() !== undefined) {
      let datalist = JSON.parse(JSON.stringify(ref.current.getDataList()));
      let lastSavedDataList = ref.current.getInitOrLastSaveData();
      let deleteList: any[] = ref.current.getDeleteList();
      if (datalist.length > 0) {
        if (this.state.procedureSaveInValue === savedInRadioValues.serverOnly) {
          // @ts-ignore
          datalist = this.checkDeleteDatalist(this.tableFiles, this.state.initProcedureDataList);
          combineDatalist = datalist.concat(deleteList);
        } else {
          datalist = this.checkUpdateDatalist(datalist, lastSavedDataList);
          combineDatalist = datalist.concat(deleteList);
        }
      } else {
        combineDatalist = [];
      }
    }
    let convertDataList = this.ConvertToBack(combineDatalist, ref);
    // @ts-ignore
    ProcedureDetailService.saveAsDraft(
      convertDataList,
      (response: any) => this._procedureSaveSuccess(response, ref),
      this._saveError
    );
  };

  /**
   * return table data when user upload files and click save then open modal
   * and change procedure saved in to client server only and click save or submit button
   * @returns
   */
  handleResetDataListInServerOnly = () => {
    const dataList: any[] = JSON.parse(JSON.stringify(this.state.initProcedureDataList));
    const deleteList: any[] = [];
    dataList.forEach((item: any) => {
      deleteList.push({
        fileOperate: 3,
        fileId: this.findDataListDataItem("fileId", item),
        fileKey: this.findDataListDataItem("fileKey", item),
        fileName: this.findDataListDataItem("fileName", item),
        uploadBy: this.findDataListDataItem("uploadBy", item),
        note: this.findDataListDataItem("note", item),
        proposeChangeTagID: this.findDataListDataItem("proposedChange", item),
        approvedDate: this.findDataListDataItem("approveDate", item),
        fileTagID: item.data.find((item: any) => item.name === "fileName").tagValue,
      });
    });
    return deleteList;
  };

  ConvertToBack = (datalist: any, ref: any) => {
    let newDataList: any[] = this.getNewDataList(datalist);
    const clientPath = ref.current !== null && ref.current.getClientPath();
    const deleteList = this.handleResetDataListInServerOnly();
    return {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      procedureFileStepId: this.state.procedureFileStepId,
      procedureSavedIn: this.state.procedureSaveInValue,
      clientServerPath: clientPath,
      fileList:
        this.state.procedureSaveInValue === savedInRadioValues.serverOnly
          ? deleteList
          : newDataList,
    };
  };

  _procedureSubmitSuccess = (result: any) => {
    this.setState({
      procedureSubmited: true,
      initOrLastSubmitProcedureSaveInValue: this.state.procedureSaveInValue,
    });
    this.props.setIsProcedureFileModalChange();
    this.props.procedureSubmitSuccess(result);
    this.handleResetLock("ProcedureFile");
  };

  hideAllModal = () => {
    this.setState({
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  findDataListDataItem = (name: any, DataItem: any) => {
    return DataItem.data.find((item: any) => item.name === name) === null ||
      DataItem.data.find((item: any) => item.name === name) === undefined
      ? ""
      : DataItem.data.find((item: any) => item.name === name).value;
  };

  getNewUpdateDataList = (datalist: any) => {
    const newDataList: any[] = [];
    datalist.forEach((item: any) => {
      const replaceUserId = this.findDataListDataItem("replaceUserId", item);
      const replaceUserName = this.findDataListDataItem("replaceUserName", item);
      const uploadByValue =
        replaceUserId && replaceUserName
          ? replaceUserId
          : this.findDataListDataItem("uploadBy", item);
      newDataList.push({
        fileOperate: 1,
        fileId: this.findDataListDataItem("fileId", item),
        fileKey: this.findDataListDataItem("fileKey", item),
        fileName: this.findDataListDataItem("fileName", item),
        uploadBy: uploadByValue,
        note: this.findDataListDataItem("note", item),
        proposeChangeTagID: this.findDataListDataItem("proposedChange", item),
        fileTagID: item.data.find((item: any) => item.name === "fileName").tagValue,
      });
    });
    return newDataList;
  };

  UpdateCovertToBack = (datalist: any, ref: any) => {
    let newDataList = this.getNewUpdateDataList(datalist);
    const clientPath = ref.current !== null && ref.current.getClientPath();
    const isClearDataList =
      this.state.procedureSaveInValue === null ||
      this.state.procedureSaveInValue === savedInRadioValues.serverOnly;
    // @ts-ignore
    const {
      currentCategory,
      currentRequestDate,
      currentRequestFrom,
      currentDesciption,
      currentAttachment,
      currentClientValue,
      currentRspValue,
      clientMemberList,
    } = revisionInfoRef.current.state;
    const rspValueName =
      clientMemberList.find((item: any) => item.value === currentRspValue)?.name ?? currentRspValue;
    return {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      procedureFileStepId: null,
      procedureSavedIn: this.state.procedureSaveInValue,
      clientServerPath: this.state.procedureSaveInValue === null ? null : clientPath,
      fileList: isClearDataList ? [] : newDataList,
      revisionForm: {
        revisionDescription: currentDesciption,
        revisionCategoryID: currentCategory,
        requestDate: getRequestDateMoment(currentRequestDate, true),
        requestFromID: currentRequestFrom,
        requestFromDesc:
          currentRequestFrom === revisionFromList.Client ? currentClientValue : rspValueName,
        attachmentFiles: [...currentAttachment],
      },
    };
  };

  handleSubmitClickAdjustDeleteFile = (convertDataList: any) => {
    // @ts-ignore
    const deleteIds = revisionInfoRef.current.state.deleteIds;
    const revisionAttachments = convertDataList.revisionForm.attachmentFiles.filter(
      (item: any) => !deleteIds.includes(item?.fileId)
    );
    convertDataList.revisionForm.attachmentFiles = revisionAttachments;

    ProcedureDetailService.updateForApproval(
      convertDataList,
      (response: any) => this._procedureSubmitSuccess(response),
      this._submitError
    );
  };

  checkProcedureFileEditOnSuccess = (response: any, ref: any) => {
    if (response.result) {
      let combineDatalist = [];
      let deleteList = ref.current.getDeleteList();
      if (ref.current.getDataList() !== undefined) {
        let datalist = JSON.parse(JSON.stringify(ref.current.getDataList()));
        let lastSavedDataList = ref.current.getInitOrLastSaveData();
        const clientPath = ref.current !== null && ref.current.getClientPath();
        if (
          this.state.procedureSaveInValue === savedInRadioValues.serverOnly &&
          clientPath.trim() !== ""
        ) {
          // @ts-ignore
          datalist = this.checkDeleteDatalist(this.tableFiles, this.state.initProcedureDataList);
        } else {
          datalist = this.checkUpdateDatalist(datalist, lastSavedDataList);
        }
        combineDatalist = datalist.concat(deleteList);
      }
      if (
        revisionInfoRef !== undefined &&
        revisionInfoRef.current !== null &&
        this.props.procedureStatus === 3
      ) {
        let convertDataList = this.UpdateCovertToBack(combineDatalist, ref);
        this.handleSubmitClickAdjustDeleteFile(convertDataList);
      } else {
        let convertDataList = this.ConvertToBack(combineDatalist, ref);
        ProcedureDetailService.submitForApproval(
          convertDataList,
          (response: any) => this._procedureSubmitSuccess(response),
          this._submitError
        );
      }
    } else {
      this.checkProcedureFileEditOnSuccessError();
    }
  };

  checkProcedureFileEditOnSuccessError = () => {
    if (this.props.procedureStatus === 3) {
      this._alertError(shareTaskMassage[35]);
    } else {
      this._alertError(shareTaskMassage[34]);
    }
    this.props.hideLoading();
  };

  checkProcedureFileEditOnError = (error: any) => {
    console.log(error);
    // this._alertError("Check Procedure Files Section Edit Error!");
  };

  handleSubmitModalConfirm = debounce(
    (ref) => {
      this.hideAllModal();
      ref.current.handleCloseModal !== undefined && ref.current.handleCloseModal();
      this.props.showLoading();
      const param = {
        procedureAccountId: this.props.procedureAccountId,
        procedureId: this.props.procedureId,
        procedureTaskId: this.props.procedureTaskId,
      };
      ProcedureDetailService.checkEditSection(
        param,
        (result: any) => this.checkProcedureFileEditOnSuccess(result, ref),
        this.checkProcedureFileEditOnError
      );
    },
    1000,
    {
      leading: true,
      trailing: false,
    }
  );

  procedureMandatoryCheck = async (ref: any) => {
    const shouldContinue = await checkLatestProcedureInfo({
      actionType: PendingActionTypes.ProcedureFilesEditSubmit,
      procedureTaskId: this.props.procedureTaskId,
      callbackType: "ONLY_MESSAGE",
    });
    if (!shouldContinue) return;

    let datalist = ref.current.getDataList();
    let lastSavedDataList = ref.current.getInitOrLastSaveData();
    if (datalist.length > 0) {
      datalist = this.checkUpdateDatalist(datalist, lastSavedDataList);
    }
    let deleteList = ref.current.getDeleteList();
    let combineDatalist = datalist.concat(deleteList);
    let convertDataList = this.ConvertToBack(combineDatalist, ref);

    let isFileAllDelete = true;
    datalist.forEach((file: any) => {
      const proposedChange = file.data.find((item: any) => item.name === "proposedChange")?.value;
      if (proposedChange !== proposedChangeTags.delete) {
        isFileAllDelete = false;
      }
    });
    const shouldShowErrorServer =
      this.state.procedureSaveInValue !== savedInRadioValues.serverOnly &&
      this.state.procedureSaveInValue !== null &&
      (datalist.length === 0 || isFileAllDelete);

    const shouldShowErrorSystem =
      this.state.procedureSaveInValue !== savedInRadioValues.systemOnly &&
      convertDataList.clientServerPath.trim() === "";

    if (revisionInfoRef !== undefined && revisionInfoRef.current !== null) {
      const modalContent = document.getElementsByClassName("modalContent")[0];
      revisionInfoMandatoryCheck(revisionInfoRef, modalContent);
    }

    if (shouldShowErrorServer) {
      ref.current.setFileTableStatus("error");
    }
    if (shouldShowErrorSystem) {
      ref.current.setClientPathStatus("error", "Please Enter Client Server Path");
      this.hideModal();
      this.props.hideLoading();
    }
  };

  handleProcedureSubmitCheckSuccess = (response: any, ref: any, isUpdateProcedure: any) => {
    const modalChildContent = isUpdateProcedure ? (
      <span>
        Are you sure to submit?
        <br />
        Please ensure that the updates made in the Procedure File section are consistent with the
        selected revision category, especially for "Procedure Storage Change".
      </span>
    ) : (
      "Are you sure to submit?"
    );
    if (response.result) {
      this.setState({
        isModalOpen: true,
        modalOkText: "Confirm",
        modalCancelText: "Cancel",
        modalChildContent: modalChildContent,
        handleModalConfirm: () => this.handleSubmitModalConfirm(ref),
        handleModalCancel: () => {},
      });
    } else {
      // @ts-ignore
      const message = shareTaskMassage[response.messageCode];
      this._alertError(message);
    }
    this.props.hideLoading();
  };

  handleProcedureSubmitCheckError = (error: any) => {
    console.log(error);
    this._alertError("Check Failed!");
    this.props.hideLoading();
  };

  handleSubmitProcedureCheck = async (ref: any) => {
    this.props.showLoading();
    const shouldContinue = await checkLatestProcedureInfo({
      actionType: PendingActionTypes.ProcedureFilesEditSubmit,
      procedureTaskId: this.props.procedureTaskId,
      callbackType: "ONLY_MESSAGE",
    });
    if (!shouldContinue) {
      this.props.hideLoading();
      return;
    }

    const param = {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
      procedureAccountId: this.props.procedureAccountId,
    };
    if (this.props.procedureStatus === 3) {
      ProcedureDetailService.checkUpdateProcedureFileSubmit(
        param,
        (response: any) => this.handleProcedureSubmitCheckSuccess(response, ref, true),
        this.handleProcedureSubmitCheckError
      );
    } else {
      ProcedureDetailService.checkCreateProcedureFileSubmit(
        param,
        (response: any) => this.handleProcedureSubmitCheckSuccess(response, ref, false),
        this.handleProcedureSubmitCheckError
      );
    }
  };

  procedureFileOnSubmit = (ref: any) => {
    if (ref.current !== null) {
      this.handleSubmitProcedureCheck(ref);
    }
  };

  checkEditSectionLock = () => {
    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: this.props.actionType,
      timeOutMins: timeOutMins,
    };
    ProcedureDetailService.checkSectionLock(
      para,
      (response: any) =>
        this.checkProcedureFileWhetherLock(response.data.isLocked, response.data.lockUser),
      (response: any) => console.log(response.message)
    );
  };

  /**
   * success callback for checkEditSection api
   * @param {object} response
   */
  checkUpdateProcedureFileEditOnSuccess = (response: any) => {
    // if (response.procedureProcessStatus !== this.props.procedureStatus) {
    //   window.location.reload();
    //   return;
    // }
    this.props.hideLoading();
    if (response.result) {
      this.checkEditSectionLock();
    } else {
      if (response.messageCode === 25) {
        this.props.setLock("This section is pending approval.");
      } else {
        // @ts-ignore
        this.props.setLock(shareTaskMassage[response.messageCode]);
      }
      this.setEditToolTipOpen(true);
      // @ts-ignore
      editRef.current.focus();
    }
  };

  /**
   * error callback for checkEditSection api
   * @param {*} error
   */
  checkUpdateProcedureFileEditOnError = (error: any) => {
    console.log(error);
    this.props.hideLoading();
    // this._alertError("Check Procedure Files Edit Error!");
  };

  handleEditCheck = async () => {
    this.props.showLoading();
    await checkLatestProcedureInfo({
      actionType: PendingActionTypes.ProcedureFilesEdit,
      procedureTaskId: this.props.procedureTaskId,
    });

    const param = {
      procedureAccountId: this.props.procedureAccountId,
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
    };
    ProcedureDetailService.checkEditSection(
      param,
      this.checkUpdateProcedureFileEditOnSuccess,
      this.checkUpdateProcedureFileEditOnError
    );
  };

  handleClientPathDisabled = (value: any) => {
    let tempClientPathDisabled;
    switch (value) {
      case savedInRadioValues.systemOnly:
        tempClientPathDisabled = true;
        break;
      case savedInRadioValues.systemAndClientServer:
        tempClientPathDisabled = false;
        break;
      case savedInRadioValues.serverOnly:
        tempClientPathDisabled = false;
        break;
      default:
        tempClientPathDisabled = true;
    }

    return tempClientPathDisabled;
  };

  _handleUpdateRadioOnClick = (value: any, ref: any) => {
    let currentValue = null;
    const dataList = ref.current.getDataList();
    // @ts-ignore
    this.tableFiles = JSON.parse(JSON.stringify(dataList));
    let tempClientPathDisabled = this.handleClientPathDisabled(value);
    if (value !== this.state.procedureSaveInValue) {
      currentValue = value;
    }

    ref.current.updateRadioValue(currentValue, this.state.procedureSaveInValue);
    this.setState({
      procedureSaveInValue: currentValue,
      procedureFlientPathDisabled: tempClientPathDisabled,
    });
    ref.current.enableOrDisableSaveSubmitCancleButton(
      ref.current.getDataList(),
      ref.current.getClientPath(),
      value
    );
  };

  updateRadioOnClick = (e: any, ref: any) => {
    this._handleUpdateRadioOnClick(e.target.value, ref);
    ref.current.clearClientPathStatus();
  };

  radioOnChange = (e: any, ref: any) => {
    this._handleRadioOnChange(e.target.value, ref);
    ref.current.clearClientPathStatus();
  };

  /* funtion about click confirm when saved in radio button changed to client server only */
  handleChangeSavedInCofirm = (value: any, ref: any) => {
    this.props.procedureStatus === 3
      ? ref.current.updateRadioValue(value, this.state.procedureSaveInValue)
      : ref.current.updateRadioValue(value);
    this.setState({
      procedureSaveInValue: value,
      procedureFlientPathDisabled: false,
      isModalOpen: false,
      modalChildContent: "",
      okText: "",
    });
  };

  /* funtion about saved in radio button change */
  _handleRadioOnChange = (value: any, ref: any) => {
    const dataList = ref.current.getDataList();
    // @ts-ignore
    this.tableFiles = JSON.parse(JSON.stringify(dataList));
    let tempClientPathDisabled = this.handleClientPathDisabled(value);
    ref.current.updateRadioValue(value);
    this.setState({
      procedureSaveInValue: value,
      procedureFlientPathDisabled: tempClientPathDisabled,
    });
    ref.current.enableOrDisableSaveSubmitCancleButton(
      ref.current.getDataList(),
      ref.current.getClientPath(),
      value
    );
  };

  handleCancelModalConfirm = (ref: any) => {
    this.hideModal();
    this.hideScrollModal();
    const dataList = JSON.parse(JSON.stringify(ref.current.getInitOrLastSaveData()));
    const clientPath = ref.current.getLastSaveClientPath();
    this._handleRadioOnChange(this.state.initOrLastSaveProcedureSaveInValue, ref);
    ref.current.updateDataList(dataList, clientPath, this.state.initOrLastSaveProcedureSaveInValue);
    ref.current.updateClientPathAndDeleteData(clientPath);
    this.handleResetLockWithoutRefresh("ProcedureFile");
    this.props.setActionType(null);
  };

  procedureFileOnCancel = (ref: any) => {
    this.setState({
      isModalOpen: true,
      modalOkText: "Confirm",
      modalCancelText: "Cancel",
      modalChildContent: "Are you sure to quit without saving?",
      handleModalConfirm: () => this.handleCancelModalConfirm(ref),
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  /* function about upload depulicate file when upload file */
  handleReplaceFile = (event: any, ref: any) => {
    // @ts-ignore
    this.fileList = [...event.target.files];
    // @ts-ignore
    if (this.fileList.length > 10) {
      this._alertError("The limit of a single upload is 10 files, no larger than 300MB each.");
      return;
    }

    // @ts-ignore
    for (let fileItem of this.fileList) {
      if (fileItem.size > 300 * 1024 * 1024) {
        this._alertError("The limit of a single upload is 10 files, no larger than 300MB each.");
        return;
      }
    }
    const tableDataList = ref.current.getDataList();
    let dataList: any[] = [];
    tableDataList.forEach((data: any) => {
      const item = data.data.find((dataItem: any) => dataItem.name === "fileName");
      dataList.push(item);
    });

    if (this.props.procedureStatus === 3) {
      this.updateFileProcess(0, dataList, tableDataList, ref);
    } else {
      this.FileProcess(0, dataList, tableDataList, ref);
    }
  };

  // @ts-ignore
  createFiles = (createFilesRef = ref, openModal: any) => {
    this.props.showLoading();
    const procedureId = this.props.procedureId;
    ProcedureDetailService.getProcedureFileSection(
      { procedureId: procedureId },
      (response: any) => {
        const newFiles = detailTableSortFile(response.procedureFiles, this._formateDate);
        let dataList;
        // @ts-ignore
        const isModal = createFilesRef === "modal";
        const filesRef = isModal ? null : createFilesRef;

        if (this.props.procedureStatus === 3) {
          dataList = createProcedureTableData.createUpdateProcedureData(newFiles, filesRef);
        } else {
          // @ts-ignore
          dataList = createProcedureTableData.createProcedureData(newFiles, filesRef);
        }

        let radioValue = response.procedureSaveInCategoryID ?? savedInRadioValues.systemOnly;
        const clientServerPath =
          response.clientServerPath === null ? "" : response.clientServerPath;

        this.setState(
          {
            procedureSaveInValue: radioValue,
            initProcedureDataList: JSON.parse(JSON.stringify(dataList)),
            initClientServerPath: clientServerPath,
            initOrLastSaveProcedureSaveInValue:
              response.procedureSaveInCategoryID === null && this.props.procedureStatus !== 3
                ? savedInRadioValues.systemOnly
                : response.procedureSaveInCategoryID,
            procedureFileStepId: response.procedureFileStepId,
            applyForJBProcessStatus: response.applyforJBProcessStatus,
            clientServerJB: response.jbProcedureSaveIn,
            procedureStatusJB: response.procedureJBStatusID,
          },
          () => openModal && openModal()
        );
        if (createFilesRef?.current) {
          // @ts-ignore
          const procedureFileData = JSON.parse(
            JSON.stringify(createFilesRef.current.getDataList())
          );
          // @ts-ignore
          createFilesRef.current.updateRadioValue(radioValue);
          // @ts-ignore
          createFilesRef.current.updateServerPathValue(clientServerPath);
          // @ts-ignore
          createFilesRef.current.updateLastSaveClientPath(clientServerPath);
          // @ts-ignore
          createFilesRef.current.updateJbProcedureSaveIn(response.jbProcedureSaveIn);
          // @ts-ignore
          createFilesRef.current.updateInitDataList(procedureFileData);
        }
        this.setState({
          procedurePendingProcessId: response.pendingProcessId,
        });
        this.props.hideLoading();
      },
      (error: any) => {
        console.log(error);
      }
    );
  };

  setEditToolTipOpen = (isOpen: any) => {
    this.setState({
      isProcedureFileEditToolTipOpen: isOpen,
    });
  };

  handleProcedureFileLock = () => {
    this.setEditToolTipOpen(true);
  };

  handleReturnModalProcedureFileTable = (isShowShareBtn: any, isShowDeleteBtn: any) => {
    const {
      procedureFlientPathDisabled,
      procedureSaveInValue,
      initOrLastSaveProcedureSaveInValue,
      initOrLastSubmitProcedureSaveInValue,
      procedureSubmited,
      procedureSaved,
      procedurePendingProcessId,
    } = this.state;
    return (
      <ProcedureBlock
        child={this.handleReturnProcedureFileTable({
          procedureFlientPathDisabled: procedureFlientPathDisabled,
          procedureSaveInValue: procedureSaveInValue,
          initOrLastSaveProcedureSaveInValue: initOrLastSaveProcedureSaveInValue,
          initOrLastSubmitProcedureSaveInValue: initOrLastSubmitProcedureSaveInValue,
          procedureSubmited: procedureSubmited,
          procedureSaved: procedureSaved,
          isShowUploadBtn: true,
          isShowDeleteBtn: isShowDeleteBtn,
          isShowDownloadBtn: true,
          isShowShareBtn: isShowShareBtn,
          isShowActionBtns: true,
          isShowProcedureFileEdit: false,
          isShowUpdate: false,
          isShowHistoryVersion: false,
          savedInDisabled: false,
          className: "procedureModalFiles",
          noteDisabled: false,
          ref: procedureModalRef,
          fileTableRef: procedureFileModalTableRef,
          pageType: this.props.pageType,
          title: "",
          hintMsg: this.props.hintMsg,
          inModal: true,
          isProcedureSection: false,
          procedurePendingProcessId: procedurePendingProcessId,
        })}
        isShowArrow={false}
        className="processProcedureModalBlock procedureFileModalBlock"
        isOpen={true}
      />
    );
  };

  openCreateModal = () => {
    this.setState({
      isScrollModalOpen: true,
      isProcedureFileEditToolTipOpen: false,
      scrollModalContent: this.handleReturnModalProcedureFileTable(false, true),
      scrollModalTitle: <HeaderWithReminder>Procedure Files</HeaderWithReminder>,
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  handleProcedureFileUnlock = () => {
    // @ts-ignore
    this.createFiles("modal", this.openCreateModal);
  };

  openUpdateModal = () => {
    this.setState({
      isScrollModalOpen: true,
      isProcedureFileEditToolTipOpen: false,
      scrollModalContent: (
        <>
          <ProcedureBlock
            child={
              // @ts-ignore
              <RevisionInformation
                title={<HeaderWithReminder>Revision Information</HeaderWithReminder>}
                updateFileNumLoading={this.props.updateFileNumLoading}
                openLoading={this.props.showLoading}
                hideLoading={this.props.hideLoading}
                accountId={this.props.procedureAccountID}
                ref={revisionInfoRef}
              />
            }
            isShowArrow={false}
            className="procedureRevisionBlock processProcedureModalBlock"
            isOpen={true}
          />
          {this.handleReturnModalProcedureFileTable(false, false)}
        </>
      ),
      scrollModalTitle: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  handleUpdateProcedureFileUnlock = () => {
    this.createFiles(procedureModalRef, this.openUpdateModal);
  };

  checkProcedureFileWhetherLock = (isLock: any, lockUser: any) => {
    if (isLock) {
      this.props.procedureStatus === 3
        ? this.props.setLock(`${lockUser} is updating this procedure.`)
        : this.props.setLock(`${lockUser} is editing this section.`);
      this.handleProcedureFileLock();
    } else {
      this.props.setActionType(this.props.actionType);
      this.props.setLock("");
      if (this.props.procedureStatus === 3) {
        this.handleUpdateProcedureFileUnlock();
      } else {
        this.handleProcedureFileUnlock();
      }
    }
  };

  handleReturnProcedureFileTable = (obj: any) => {
    const {
      procedureFlientPathDisabled,
      procedureSaveInValue,
      initOrLastSaveProcedureSaveInValue,
      initOrLastSubmitProcedureSaveInValue,
      procedureSubmited,
      procedureSaved,
      isShowUploadBtn,
      isShowDeleteBtn,
      isShowDownloadBtn,
      isShowShareBtn,
      isShowActionBtns,
      isShowProcedureFileEdit,
      isShowUpdate,
      isShowHistoryVersion,
      savedInDisabled,
      className,
      noteDisabled,
      ref,
      fileTableRef,
      pageType,
      title,
      hintMsg,
      inModal,
      isProcedureSection,
    } = obj;

    const {
      initClientServerPath,
      isProcedureFileEditToolTipOpen,
      initProcedureDataList,
      isShowApplyJbButton,
      isShowJbProcedureSaved,
      isShowTableJbProcedure,
      isShowTLButton,
      procedurePendingProcessId,
      applyForJBProcessStatus,
      clientServerJB,
      procedureStatusJB,
    } = this.state;
    const {
      procedureId,
      procedureTaskId,
      procedureAccountId,
      procedureStatus,
      procedureJbStatusId,
      taskInformationData,
      showLoading,
      hideLoading,
      setActionType,
    } = this.props;

    const componentProps = {
      fileInputRef: procedureFileRef,
      fileTableRef: fileTableRef,
      title: title,
      clientPathShow: true,
      clientPathDisabled: procedureFlientPathDisabled,
      handleFileSelect: (e: any) => this.handleReplaceFile(e, ref),
      savedInRadioValue: procedureSaveInValue,
      clientPath: initClientServerPath,
      initOrLastSaveProcedureSaveInValue: initOrLastSaveProcedureSaveInValue,
      initOrLastSubmitProcedureSaveInValue: initOrLastSubmitProcedureSaveInValue,
      onSave: () => this.procedureFileOnSave(ref),
      onSubmit: () => this.procedureFileOnSubmit(ref),
      onCancel: () => this.procedureFileOnCancel(ref),
      handleSubmitModalConfirm: () => this.handleSubmitModalConfirm(ref),
      hasSubmit: procedureSubmited,
      hasSave: procedureSaved,
      isScrollData: true,
      className: className,
      isShowExpendIcon: true,
      isShowUploadBtn: isShowUploadBtn,
      isShowDeleteBtn: isShowDeleteBtn,
      isShowDownloadBtn: isShowDownloadBtn,
      isShowShareBtn: isShowShareBtn,
      isShowActionBtns: isShowActionBtns,
      isShowProcedureFileEdit: isShowProcedureFileEdit,
      isShowUpdate: isShowUpdate,
      isShowHistoryVersion: isShowHistoryVersion,
      handleEditClick: () => this.handleEditCheck(),
      savedInDisabled: savedInDisabled,
      hintMsg: hintMsg,
      isEditToolTipOpen: isProcedureFileEditToolTipOpen,
      onBlur: () => this.setEditToolTipOpen(false),
      noteDisabled: noteDisabled,
      pageType: pageType,
      status: procedureStatus,
      initProcedureDataList: initProcedureDataList,
      initClientServerPath: initClientServerPath,
      procedureMandatoryCheck: () => this.procedureMandatoryCheck(ref),
      isShowTLButton: isShowTLButton,
      isShowApplyJbButton: isShowApplyJbButton,
      isShowJbProcedureSaved: isShowJbProcedureSaved,
      isShowTableJbProcedure: isShowTableJbProcedure,
      procedureId: procedureId,
      procedureTaskId: procedureTaskId,
      procedureAccountId: procedureAccountId,
      procedureStatus: procedureStatus,
      revisionInfoRef: revisionInfoRef,
      inModal: inModal,
      procedureJbStatusId: procedureJbStatusId,
      taskInformationData: taskInformationData,
      isProcedureSection: isProcedureSection,
      isProcedureFile: true,
      _showLoading: showLoading,
      _hideLoading: hideLoading,
      setActionType: setActionType,
      procedurePendingProcessId: procedurePendingProcessId,
      isProcedureDetailSection: true,
      applyForJBProcessStatus: applyForJBProcessStatus,
      editRef: editRef,
      isShowSavedInIcon: !isProcedureSection && procedureStatus === 3,
      clientServerJB: clientServerJB,
      procedureStatusJB: procedureStatusJB,
    };

    return procedureStatus === 3 ? (
      <UpdateProcedureFileManagement
        ref={ref}
        handleRadioChange={() => {}}
        handleRadioClick={(e: any) => {
          this.updateRadioOnClick(e, ref);
        }}
        {...componentProps}
        title="Procedure Files"
      />
    ) : (
      <DetailFileManagement
        ref={ref}
        handleRadioClick={() => {
          // empty function
        }}
        handleRadioChange={(e: any) => {
          this.radioOnChange(e, ref);
        }}
        {...componentProps}
      />
    );
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      prevProps.procedureStatus !== this.props.procedureStatus ||
      prevProps.procedureAccountId !== this.props.procedureAccountId
    ) {
      if (
        this.isTlAndAbove() &&
        (this.props.procedureStatus === 3 || this.props.procedureStatus === 7)
      ) {
        this.setState({
          isShowTLButton: true,
        });
      }

      if (
        this.isAsAndAbove() &&
        (this.props.procedureStatus === 3 || this.props.procedureStatus === 7)
      ) {
        this.setState({
          isShowApplyJbButton: true,
        });
      }
    }
    const pendingAction = getPendingAction();
    if (
      pendingAction === PendingActionTypes.ProcedureFilesEdit &&
      this.props.procedureAccountID !== undefined
    ) {
      this.handleEditCheck();
    }
  }

  updateModalWidth = () => {
    if (!this.state.isScrollModalOpen) return;
    this.setState({
      ...this.state,
    });
  };

  componentDidMount() {
    this.updateModalWidth();
    window.addEventListener("resize", this.updateModalWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateModalWidth);
  }

  render() {
    const { isShowTable, pageType, procedureStatus } = this.props;
    // @ts-ignore
    const modalWidth =
      document.getElementsByClassName("procedureBlock")[0] !== undefined &&
      document.getElementsByClassName("procedureBlock")[0].offsetWidth;
    return (
      <>
        <ProcedureBlock
          child={
            isShowTable &&
            this.handleReturnProcedureFileTable({
              procedureFlientPathDisabled: true,
              procedureSaveInValue: this.state.procedureSaveInValue,
              initOrLastSaveProcedureSaveInValue: this.state.initOrLastSaveProcedureSaveInValue,
              initOrLastSubmitProcedureSaveInValue: this.state.initOrLastSubmitProcedureSaveInValue,
              procedureSubmited: this.state.procedureSubmited,
              procedureSaved: this.state.procedureSaved,
              isShowUploadBtn: false,
              isShowDeleteBtn: false,
              isShowDownloadBtn: true,
              isShowShareBtn: true,
              isShowActionBtns: false,
              isShowProcedureFileEdit: this.props.isShowProcedureFileEdit,
              isShowUpdate: false,
              isShowHistoryVersion: procedureStatus === 3 || procedureStatus === 7,
              savedInDisabled: true,
              className: "procedureFiles",
              noteDisabled: true,
              ref: ref,
              fileTableRef: procedureFileTableRef,
              pageType: pageType,
              title: "Procedure Files",
              hintMsg: this.props.hintMsg,
              inModal: false,
              isProcedureSection: true,
              procedurePendingProcessId: this.state.procedurePendingProcessId,
            })
          }
          isShowArrow={false}
          className="processProcedureBlock procedureFileBlock"
          isOpen={true}
        />
        <NormalModal
          testid="procedure-file-modal"
          okText={this.state.modalOkText}
          cancelText={this.state.modalCancelText}
          childContent={<p className="fs-16">{this.state.modalChildContent}</p>}
          isModalOpen={this.state.isModalOpen}
          handleOk={this.state.handleModalConfirm}
          handleCancel={() => {
            this.state.handleModalCancel();
            this.hideModal();
          }}
          closable={false}
          okButtonTestid="procedure-file-modal-ok-btn"
          cancelButtonTestid="procedure-file-modal-cancel-btn"
        />
        <ModalWithScroll
          testid="procedure-file-scroll-modal"
          isModalOpen={this.state.isScrollModalOpen}
          modalContent={this.state.scrollModalContent}
          title={this.state.scrollModalTitle}
          width={modalWidth}
          actionType={this.props.actionType}
        />
      </>
    );
  }
}
